import { ShareScreenBase } from "./share-screen-base"
import { RoomContentCard } from "./room-content-card"
import { getRoomDeeplinkUrl } from "~/common/platform"
import { getMetaContent, getMetaContentMaybe } from "~/common/get-meta-content"
import { ShareRoomFragment, VerificationLink } from "~/__generated__/graphql"
import { useDocumentTitleDescription } from "~/common/use-document-title"

export const ShareRoomScreen = (): JSX.Element => {
  const roomData = getMetaContentMaybe("room-data", { json: true }) as ShareRoomFragment | null

  const appEnvironment = getMetaContent<string>("APP_ENVIRONMENT")
  const deeplinkUrl = roomData?.id ? getRoomDeeplinkUrl(appEnvironment, roomData.id) : undefined
  const roomTitle = roomData?.name ? [roomData.name, "on ChatBCC"].join(" ") : null
  useDocumentTitleDescription(roomTitle, roomData?.description ?? null)

  return (
    <ShareScreenBase
      verificationLinkType={VerificationLink.RoomShare}
      roomHandle={roomData?.roomHandle}
      roomId={roomData?.id}
      deeplinkUrl={deeplinkUrl}
      renderContent={() =>
        roomData && <RoomContentCard roomData={roomData} className="max-w-[640px]" />
      }
    />
  )
}

export default ShareRoomScreen
